import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation } from "@tanstack/react-query";
import { CUSTOMER_SEARCH_RESOURCE } from "./use-customer-search.query";

export const CUSTOMER_EXPORT_API_PATH = `/v1/${CUSTOMER_SEARCH_RESOURCE}/{uuid}/export-sync` as const;

export type CustomerExportResponse =
  paths[typeof CUSTOMER_EXPORT_API_PATH]["post"]["responses"][202]["content"]["application/json"];
export type CustomerExportBody =
  paths[typeof CUSTOMER_EXPORT_API_PATH]["post"]["requestBody"]["content"]["application/json"];

export const useCustomerExportMutation = () => {
  return useMutation<CustomerExportResponse, Error, { uuid: string; body: CustomerExportBody }>({
    mutationFn: async ({ uuid, body }) => {
      const response = await alphartisApiAxios.post<CustomerExportResponse>(
        CUSTOMER_EXPORT_API_PATH.replace("{uuid}", uuid),
        body,
      );
      return response.data;
    },
  });
};
